import { createRouter, createWebHistory } from 'vue-router'
import { loadModuleRoutes } from './routes'
import { authGuard, abacGuard, roleGuard } from './guards'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: loadModuleRoutes(),
  scrollBehavior(to, _from, savedPosition) {
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth', top: 80 }
    }
    return savedPosition ?? { top: 0, behavior: 'smooth' }
  },
})

router.beforeEach(authGuard)
router.beforeEach(abacGuard)
router.beforeEach(roleGuard)

export default router
